(function() {
  'use strict';

  angular
    .module('iqxCore')
    .service('configSvc', configSvc)

  function configSvc(ApplicationSvc){
    var svc = this
    svc.check = check

    ///////////

    function check(params){
      var type = Object.prototype.toString.call(params)
      if(type === "[object String]"){
        return !!ApplicationSvc.params[params]
      }else if(type === '[object Array]'){
        var arrayLength = params.length
        for(var i = 0; i < arrayLength; i++){
          if(!ApplicationSvc.params[params[i]]){
            return false
          }
        }
        return true
      }else{
        throw new Error('Parameter switches must be of type string or array')
      }
    }

  }

})()